export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const SET_MODAL_COMPONENT = 'SET_MODAL_COMPONENT'
export const SET_STYLE = 'SET_STYLE'
export const SET_TITLE = 'SET_TITLE'
export const SET_CANCEL = 'SET_CANCEL'
export const SET_VALIDATE = 'SET_VALIDATE'
export const SET_MODAL_WARNING = 'SET_MODAL_WARNING'
export const CLEAR_MODAL_WARNING = 'CLEAR_MODAL_WARNING'
export const SET_MODAL_CACHE = 'SET_MODAL_CACHE'
export const CLEAR_MODAL_CACHE = 'CLEAR_MODAL_CACHE'
